export default __webpack_public_path__ + "static/media/779.c1e91d27.png";